module.exports = __webpack_public_path__ + "media/theme/icon__master-bdc3f57e.png";